module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-23.7e4c6e69.png";